import Tercept from "components/shared/Tercept/Tercept";

window.Tercept = Tercept;
Tercept.load();